module.exports = __webpack_public_path__ + "img/solace.626369f0.png";